/**
 * A ESCALA TIPOGRÁFICA DA CASA — 6 tamanhos, e mais nenhum.
 *
 * Nasceu no redesign do operador (mock da Torre, aprovado pelo dono em 24/08)
 * depois que a medição ao vivo achou 12 tamanhos distintos na Torre com o
 * corpo dominante (11px) carregando só 36% do texto — e meios-pixels
 * arbitrários (11,5 / 12,5 / 13,5) espalhados até no portal v3. A referência
 * de painel usa ~6 tamanhos com ~75% do texto num corpo só; a tela de Centros
 * da própria casa (4 tamanhos) provou que a régua cabe.
 *
 *   micro  11px  eyebrow, selo, rótulo de KPI
 *   apoio  12px  metadado, legenda, célula secundária
 *   corpo  13px  TODO o texto corrido — alvo ≥ 70% da tela
 *   sub    15px  nome de cliente, título de cartão/seção interna
 *   secao  18px  título de seção grande / saudação de página
 *   kpi    22px  número-herói — NUNCA 24+ (Constituição: 21–22)
 *
 * Uso: `className={ESCALA.corpo}` — string de classe Tailwind LITERAL (as seis
 * existem escritas aqui, então o compilador as enxerga; classe montada por
 * template é a Tailwind fantasma que falha em silêncio).
 *
 * A adoção é POR ONDA: a Torre é a 1ª consumidora (R1); cada onda seguinte
 * migra as suas telas. A régua `tests/regula-escala-tipografica.test.ts`
 * tranca as telas JÁ migradas — tela que entra na lista não volta a inventar
 * tamanho.
 */
export const ESCALA = {
  micro: "text-[11px]",
  apoio: "text-[12px]",
  corpo: "text-[13px]",
  sub: "text-[15px]",
  secao: "text-[18px]",
  kpi: "text-[22px]",
} as const;

export type NomeDaEscala = keyof typeof ESCALA;

/** Os seis valores em px — pra régua e pra quem precisa do número (gráficos). */
export const ESCALA_PX: Record<NomeDaEscala, number> = {
  micro: 11,
  apoio: 12,
  corpo: 13,
  sub: 15,
  secao: 18,
  kpi: 22,
};
